export default "__VITE_ASSET__DiaLkai3__"